import { PlessResponderSub } from '../../../../commons/kymw00/pless-responder-sub.service';
import { KYMW1402Model } from '../kymw1402.model';
import { PageDataModel } from '../../kymw1400/vo/page-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 印刷ページデータを取得する。
 *
 * @export
 * @class GetPrintPageDataService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPrintPageDataService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: KYMW1402Model = null;
  private vo: PageDataModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPrintPageDataService
   */
  private getBody(): PlessRequest {
    // 生協リストを作成する
    const coopCodes =
      ((0 == this.vo.coopCodeList.length) ? [ null ] : this.vo.coopCodeList)
        .map(coopCode => ({
          condition: {
            CoopCode: coopCode,
            PageNum: null
          }
        }));

    return new PlessRequest({
      search: {
        PrintPageData: {
          condition: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType
          },
          combination: coopCodes
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1402Model} model モデルクラス
   * @param {PageDataModel} vo パラメータ
   * @memberof GetPrintPageDataService
   */
  execute(model: KYMW1402Model, vo: PageDataModel) {
    this.model = model;
    this.vo = vo;
    this.send('getPrintPageData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPrintPageDataService
   */
  success(data: any) {
    // 結果データの編集
    this.model.setPrintPageData(data);
  }
}
